import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/MerchandisePrizeDraw/Detail/:id",
  component: function component() {
    return import("../../../views/dev-plug/merchandise-prize-draw/index");
  },
  name: "MerchandisePrizeDrawDetail",
  meta: {
    foot: true
  }
}];